<template>
  <Wrap :title="$t('web_app.homeNotice.announce')" @closeClick="handleCloseClick" :className="'announcement'">
    <div class="message_content">
      <div v-html="announcement.content"></div>
      <div
        class="more"
        v-baidu-event-tracking="{ feature: '首页公告弹窗', action: '查看公告' }"
        @click="view_details"
        v-if="announcement.url"
      >
        {{ $t('web_app.homeNotice.announce_more') }}
      </div>
    </div>
  </Wrap>
</template>
<script>
import Wrap from './Wrap.vue'
import logClickEvent from '../../utils/logClickEvent'
export default {
  name: 'AnnouncementMessage',
  components: {
    Wrap,
  },
  computed: {
    announcement() {
      return this.$store.getters['announcement/announcement']
    },
  },
  methods: {
    handleCloseClick() {
      logClickEvent('首页公告弹窗', '关闭')
      this.$store.dispatch('announcement/hide')
      this.$emit('closeClick')
    },
    view_details() {
      // 标题点击
      if (!this.announcement.url) {
        return
      }
      window.open(this.announcement.url)
    },
  },
}
</script>
<style lang="scss">
.announcement {
  .wrap_header_title {
    &:hover {
      cursor: default;
    }
  }
}
</style>
